import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

interface AuthContextType {
  token: string | null;
  setToken: (jwt_token: string | null) => void;
  isAuthenticated: boolean;
  logout: () => void;
  user: any;
}

const ROTA_LOGOUT_BACK = '/pgrm/api/auth/logout';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [tokenState, setTokenState] = useState<string | null>(null);
  const [user, setUser] = useState<any>(null);

  const logout = () => {
    window.location.href = ROTA_LOGOUT_BACK;
  };

  const setToken = (newToken: string | null) => {
    if (newToken) {
      localStorage.setItem('jwt_token', newToken);
      setTokenState(newToken);
    } else {
      localStorage.removeItem('jwt_token');
      setTokenState(null);
    }
  };

  useEffect(() => {
    const storedToken = localStorage.getItem('jwt_token');
    if (storedToken) {
      setTokenState(storedToken);
      setUser(jwtDecode(storedToken));
    }
  }, [tokenState]);

  useEffect(() => {
    const timestampAgora = Date.now() / 1000;
    const isTokenValido = user?.exp && user?.exp < timestampAgora;

    if (isTokenValido) {
      logout();
      setToken(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <AuthContext.Provider
      value={{
        token: tokenState,
        setToken,
        isAuthenticated: !!tokenState,
        logout,
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context)
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  return context;
};
